<div class="leave-dialog-panel-section">
  <!-- Dismiss button -->
  <div class="leave-dialog-panel-dismiss">
    <button mat-icon-button matDialogClose="cancelled">
      <mat-icon class="text-secondary" svgIcon="close-icon"></mat-icon>
    </button>
  </div>

  <div class="leave-dialog-panel-content">
    <img src="assets/unsaved.png" alt="" />
    <div class="title">{{ 'GENERAL.UNSAVED_CHANGES_TITLE' | translate }}</div>
    <div class="message">
      {{ 'GENERAL.UNSAVED_CHANGES_MSG' | translate }}
    </div>
  </div>

  <div class="leave-dialog-panel-action">
    <!-- Cancel -->
    <button class="secondary-button" matDialogClose="cancelled">
      {{ 'GENERAL.STAY' | translate }}
    </button>
    <!-- Confirm -->
    <button class="primary-button" matDialogClose="leave">
      {{ 'GENERAL.LEAVE' | translate }}
    </button>
  </div>
</div>
